export class RotationManager {

    constructor() {
        this.activeInterval = null
    }

    start(rotateCallback) {

        this.stop()
        this.activeInterval = setInterval(rotateCallback, 5000)

    }

    stop() {

        if (this.activeInterval) {

            clearInterval(this.activeInterval)
            this.activeInterval = null

        }

    }

}
